import { render, staticRenderFns } from "./AddressHeader.vue?vue&type=template&id=bfdc0c5e"
import script from "./AddressHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./AddressHeader.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports